import InputField from "components/fields/InputField";
import SelectField from "components/fields/SelectField";
import TimeInput from "components/fields/TimeInputField";
import UrlTextBoxes from "components/fields/UrlFieldBoxes";
import { useEffect } from 'react';
import { setScheduleDay, setMeetingDuration,setMeetingLocation,
  setStartTime,
  setEndTime,
  setTimezone, setMeetingLink1, setMeetingLink2, EventStatePayload, setDefault } from '../../../../../redux/eventSlice';
  import { RootState } from '../../../../../redux/store';
  

  import { useSelector, useDispatch } from 'react-redux';

type CreateEventProps = {
  eventObject?: EventStatePayload;
};

const CreateEvent = ({ eventObject }:CreateEventProps) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setDefault());
  }, [dispatch]); 

  const emailStr = localStorage.getItem("email");
  const  mailArr = emailStr.split('@');

  const event = useSelector((state: RootState) => state.event.payload);
  const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  useEffect(() => {
    if(mailArr && mailArr.length !==0) {
      dispatch(setMeetingLink1(mailArr[0]));
      dispatch(setMeetingLink2(`15min`));

    }
  }, [!eventObject]); 
  const timezoneOptions = [{ value: defaultTimezone, label: defaultTimezone }];

    useEffect(() => {
      
      if(eventObject) {
        dispatch(setScheduleDay(eventObject.scheduleDays));
        dispatch(setMeetingDuration(eventObject.meetingDuration));
        dispatch(setMeetingLocation(eventObject.meetingLocation));
        dispatch(setStartTime(eventObject.startTime));
        dispatch(setEndTime(eventObject.endTime));
        dispatch(setTimezone(defaultTimezone));
        const meetingLink = eventObject && eventObject.meetingLink ? eventObject.meetingLink : '';
        const parts = meetingLink.split("/");
        dispatch(setMeetingLink1(parts[1]));
        const part = parts[2] ? parts[2] : `${eventObject.meetingDuration}min`;
        dispatch(setMeetingLink2(part));
        console.log('eventObject__a_',eventObject);

      }
    }, [eventObject]); 
  const handleMeetingLink1 = (event:any) => {
    dispatch(setMeetingLink1(event.target.value));

  };

  const handleMeetingLink2 = (event: any) => {
    dispatch(setMeetingLink2(event.target.value));
  };

  const scheduleDays = (event:any) => {
    dispatch(setScheduleDay(event.target.value));
  };

  const meetingDuration = (event:any) => {
    dispatch(setMeetingDuration(event.target.value));
    dispatch(setMeetingLink2(`${event.target.value}min`));

  };
  
  const handleTimeZoneChange = (event:any) => {
    dispatch(setTimezone(event.target.value));
  };

  const handleMeetingLocationChange = (event:any) => {
    dispatch(setMeetingLocation(event.target.value));
  }


  const dayOptions = [
    { value: '7', label: '7 days' },
    { value: '10', label: '10 days' },
    { value: '15', label: '15 days' },
    { value: '30', label: '30 days' },
    { value: '45', label: '45 days' },
    { value: '60', label: '60 days' },
    { value: '90', label: '90 days' },
  ];

  const meetingDurationOptions = [
    { value: '15', label: '15 min' },
    { value: '30', label: '30 min' },
    { value: '45', label: '45 min' },
    { value: '60', label: '60 min' },
    { value: '120', label: '120 min' }
  ];

  const locationOfMeeting = [
    { value: 'googleMeet', label: 'Google Meeting' },
    { value: 'teamsMeeting', label: 'Teams Meeting' },
    { value: 'linkOnEmail', label: 'Meeting Link on Email' },
    { value: 'offlineMeeting', label: 'Offline Meeting (Address in Email)' }
  ];

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">


      {/* content */}

      <div className="mt-7 grid grid-cols-1 gap-3 md:grid-cols-2">
           
      <SelectField
        id="day-options"
        selectdValue={event.scheduleDays}
        label="Invitees can schedule Calendar days *"
        placeholder={event.scheduleDays}
        options={dayOptions}
        onChange={scheduleDays}
      />

      <SelectField
        id="meeting-duration"
        selectdValue={event.meetingDuration}
        label="Meeting Duration In Mins *"
        placeholder={event.meetingDuration}
        options={meetingDurationOptions}
        onChange={meetingDuration}
      />
      <TimeInput
        id="day-start-time"
        label="Day Start Time *"
        value={event.startTime}
        onChange={(e) => dispatch(setStartTime(e.target.value))}
      />
      <TimeInput
        id="day-end-time"
        label="Day End Time *"
        value={event.endTime}
        onChange={(e) => dispatch(setEndTime(e.target.value))}
      />
        <SelectField
          id="select_timezone"
          label="Select TimeZone *"
          selectdValue={event.timezone}
          placeholder={event.timezone}
          options={timezoneOptions}
          onChange={handleTimeZoneChange}
        />
         <UrlTextBoxes
        label1="app.bookameeting.co/**/**"
        placeholder1="Enter sub url"
        type1="text"
        label2=" ."
        value1={event.meetingLink1}
        value2={event.meetingLink2}
        onChange1={handleMeetingLink1}
        onChange2={handleMeetingLink2}

        placeholder2="Enter sub url"
        type2="text"
      />
        <SelectField
          id="location-meeting"
          label="Location of the meeting *"
          selectdValue={event.meetingLocation}
          placeholder={event.meetingLocation}
          options={locationOfMeeting}
          onChange={handleMeetingLocationChange}
        />
        
       
      </div>
    </div>
  );
};

export default CreateEvent;
